



















































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
export default {
   
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const renderJobSkillSelect = companyRecruitment.renderJobSkillSelect
    
    const data = computed(() => companyRecruitment.skillSearch.data)
    //const data = [{ "major_code": "004", "small_code": "004002", "small_name": "キッチン経験 一年以下" }, { "major_code": "004", "small_code": "004005", "small_name": "ホール経験 一年以上" }]
    const skillSearch = computed(() => companyRecruitment.skillSearch);
    const selectAll = computed(() => companyRecruitment.skillSelectAll);
    const select = computed(() => companyRecruitment.skillSelect);

    const dialogSkillSearch = computed(() => displayui.dialogSkillSearch);
     const closeDialogSkillSearch = computed(() => displayui.closeSkillSearchDialog);
    return {
      skillSearch,
      selectAll,
      select,
      data,
      dialogSkillSearch,
      closeDialogSkillSearch
    };
  },
}
